import { smoothScroll } from '..'

/**
 * ドロワーメニューの開閉機能
 */
export class Drawer {
  constructor() {
    this.body = document.body
    this.overlay = document.getElementById('js-overlay')
    this.hamburger = document.getElementById('js-hamburger')
    this.drawer = document.getElementById('js-drawer')
    this.modals = document.querySelectorAll('.js-modal_body')
    this.header = document.getElementById('js-header')
    this.link = this.drawer.querySelectorAll('a')
    if (this.hamburger === null || this.drawer === null) return

    this.hamburger.addEventListener('click', () => {
      this.hamburger.classList.toggle('is-act')
      this.header.classList.toggle('is-act')
      if (this.hamburger.classList.contains('is-act')) {
        this.animation(this.drawer, 'open')
      } else {
        this.animation(this.drawer, 'close')
      }
    })
    this.overlay.addEventListener('click', () => {
      if (this.hamburger.classList.contains('is-act')) {
        this.animation(this.drawer, 'open')
      } else {
        this.animation(this.drawer, 'close')
      }
    })
    this.link.forEach((elm) => {
      elm.addEventListener('click', () => {
        this.hamburger.classList.remove('is-act')
        this.header.classList.remove('is-act')
        this.animation(this.drawer, 'close')
      })
    })
  }
  animation(el, type) {
    if (type == 'open') {
      this.overlay.classList.add('is-act')
      this.drawer.classList.add('is-open')
      this.body.classList.add('is-act')
    } else {
      this.overlay.classList.remove('is-act')
      this.drawer.classList.remove('is-open')
      this.body.classList.remove('is-act')
      this.modals.forEach((elm) => {
        elm.classList.remove('is-open')
      })
    }
  }
}
